import { render } from "./Alert.vue?vue&type=template&id=c8870590&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=c8870590&scoped=true&lang=css"
import "@/styles/header.css?vue&type=style&index=1&id=c8870590&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=2&id=c8870590&scoped=true&lang=css&external"
import "@/styles/subcommon.css?vue&type=style&index=3&id=c8870590&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../../Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8870590"]])

export default __exports__